window.addEventListener("load", function() {
  removeFreeCartItems();
  const screenWidth = window.innerWidth + 5;
  const productScrollLists = document.querySelectorAll(".product-list.one-row");
  setScrollIndicatingArrows(screenWidth, productScrollLists); 
});

window.addEventListener("resize", function() {
  //clearScrollIndicatingArrows(productScrollLists);
});

function repaintMiniCart() {
  removeFreeCartItems();
  //$('.nudge-offer').remove();
  const path = window.location.pathname;
  const prefix = path.split("/")[1];
  var url = '/cart?view=mini';
  if(prefix == 'sv' || prefix == 'de' || prefix == 'da' || prefix == 'fr' || prefix == 'no') {
    url = "/" + prefix + url; 
  }
  fetch(url, {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {
    content.text().then(function(html){ 
      $('.sidebar-drawer__content').html(html.replace('<script class="cartFlagX"></script>','').replace('<template data-options>','').replace('{}','').replace('</template>','').replace('<template data-html="content">','').replace('<template data-html="footer">',''))
      //$('.cart-mini-content').html(html.replace('<script class="cartFlagX"></script>','').replace('<template data-options>','').replace('{}','').replace('</template>','').replace('<template data-html="content">','').replace('<template data-html="footer">',''));
      //$('.cart-mini-content .free-shipping-bar').remove();
      //$('.cart-mini-content .cart-mini-footer').remove();
      //$('.cart-mini-content .cart-mini-subtotal').remove();
      //$('.cart-mini-content .cart-mini-actions').remove();
      //document.querySelector(".cart-mini-content .cart-mini-items").style.padding = 0;
    });
  });

  setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
      //document.querySelector('.cart-mini-subtotal-value').innerHTML = cart.total_price / 100;
      $('[data-cart-mini-count]').html(cart.item_count == 0 ? '' : cart.item_count);
    });
    const sidebar = document.querySelector("[data-sidebar-drawer-container]");
  }, 200);
}

function openMiniCart() {
  const miniCart = document.querySelector(".sidebar-drawer-container");
  const miniCartState = miniCart.dataset.sidebarDrawerAnimationState;
  if(miniCartState == 'closed') {
    miniCart.dataset.sidebarAnimation = 'closed=>open';
    miniCart.dataset.sidebarDrawerAnimationState = 'open';
  }
}

function addItemsToCart(elem, refresh = false) {
  const variantIds = elem.dataset.variantIds;
  const elemsToRemove = document.querySelectorAll("[data-is-unselected]");
  let variantIdsToRemove = [];
  if(elemsToRemove.length > 0) {
    for(var i = 0; i < elemsToRemove.length; i++) {
      const variantId = elemsToRemove[i].dataset.productVariantId.trim();
      variantIdsToRemove.push(variantId);
    }
  }
  let array = variantIds.split(",");

  array = array.filter(item => !variantIdsToRemove.includes(item));

  if(array.length > 0) {
    let formData = { items: [] };
    for(var i = 0; i < array.length; i++) {
      formData.items.push({id: array[i], quantity: 1});
    }
    addToCart(formData, refresh);
  }
}

function addItemToCart(variantId, refresh = false) {
  const formData = { 
    items: [
      {
        id: variantId, 
        quantity: 1
      }
    ] 
  };
  addToCart(formData, refresh);
  /*if(refresh == false) {
    openMiniCart();
  }*/
}

function addToCart(formData, redirect = false) {
  return new Promise(function(resolve, reject) {
    fetch('/cart/add.js', {
    method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      resolve(response);
      if(document.querySelector(".template-cart") != null) {
        window.location.reload();
      } else {
        //window.location.assign('/cart');
        //also open mini cart if not taking place in cart!
        if(redirect) {
          const path = window.location.pathname;
          const prefix = path.split("/")[1];
          var url = '/cart';
          if(prefix == 'sv' || prefix == 'de' || prefix == 'da' || prefix == 'fr' || prefix == 'no') {
            url = "/" + prefix + url; 
          }
          window.location = url;
        } else {
          repaintMiniCart();
        }
        if(type == 'product') {
          document.getElementById(variantId).remove();
        }
      }
    })
    .catch(error => {
      reject(error);
      return;
    })
  });
}

function removeItemFromCart(variantId, quantity = 0) {
  return new Promise(function(resolve, reject) {
    fetch('/cart/change.js', {
    method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ quantity: quantity, id: variantId.toString() })
    })
    .then(response => response.json())
    .then(response => {
      resolve(response);
      if(document.querySelector(".template-cart") != null) {
        window.location.reload();
      } else {
        //window.location.assign('/cart');
        repaintMiniCart();
      }
    })
    .catch(error => {
      reject(error);
      return;
    })
  });
}

function removeFreeCartItems() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => response.json())
  .then(response => {
    const cartItems = response.items;
    if(response.item_count > 0 && response.total_price == 0) {
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then(response => {
        repaintMiniCart();
        // all items removed
      });
    }
    /*for(var i = 0; i < cartItems.length; i++) {
      if(response.total_price == 0) {
        removeItemFromCart(cartItems[i].id)
      }
    }*/
  });
}

function handleAssociatedProductClick(elem) {
  elem.toggleAttribute('data-is-unselected');
  const elemPrice = parseInt(elem.getAttribute("data-price"));
  const totalPriceElem = document.querySelector(".product-works-well-with-price");
  const totalPrice = parseInt(totalPriceElem.getAttribute("data-total-price"));
  let newPrice = totalPrice;
  const summaryElem = document.querySelector("[data-summary-element]");

  if(elem.getAttribute('data-is-unselected') == "") {
    // gets unselected
    newPrice = totalPrice - elemPrice;
  } else {
    //gets selected
    newPrice = totalPrice + elemPrice;
  }
  totalPriceElem.setAttribute("data-total-price", newPrice);

  const formattedNewPrice = newPrice / 100;
  if(newPrice < 1) {
    summaryElem.style.visibility = "hidden";
  } else {
    summaryElem.style.visibility = "visible";
    totalPriceElem.innerHTML = formattedNewPrice;
  }
}

function scrollIndicatingArrowsEvent() {
  const screenWidth = window.innerWidth + 5;
  const parent = this.closest(".home-section");
  const containerWidth = this.scrollWidth;
  const containerScroll = this.scrollLeft;
        
  if(this.scrollLeft > 1) {
    parent.dataset.leftArrow = true;
  } else {
    parent.dataset.leftArrow = false;
  }

  if(containerScroll + screenWidth >= containerWidth) {
    parent.dataset.rightArrow = false;
  } else {
    parent.dataset.rightArrow = true;
  }
}

function setScrollIndicatingArrows(screenWidth, elems) {
  for(var i = 0; i < elems.length; i++) {
    const parent = elems[i].closest(".home-section");
    const containerWidth = elems[i].scrollWidth;
    if(containerWidth > screenWidth) {
      parent.dataset.rightArrow = true;
    }
    elems[i].addEventListener("scroll", scrollIndicatingArrowsEvent);
  }
}

function clearScrollIndicatingArrows(elems) {
  for(var i = 0; i < elems.length; i++) {
    const parent = elems[i].closest(".home-section");
    parent.dataset.leftArrow = false;
    parent.dataset.rightArrow = false;
    elems[i].removeEventListener("scroll", scrollIndicatingArrowsEvent);
  }
}


function handleCartQuantityChange(elem) {
  var newVal = elem.getAttribute('value');
  var currentVariant = elem.dataset.variantId;

  return new Promise(function(resolve, reject) {
    fetch('/cart/change.js', {
    method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ quantity: newVal, id: currentVariant })
    })
    .then(response => response.json())
    .then(response => {
      resolve(response);
      if(document.querySelector(".template-cart") != null) {
        window.location.reload();
      } else {
        //window.location.assign('/cart');
        repaintMiniCart();
      }
    })
    .catch(error => {
      reject(error);
      return;
    })
  });
}
